var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyArrow3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 88,
    viewBox: "0 0 143 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 210",
    d: "M2 44.27C17.1567 32.6627 37.099 23.0569 56.6745 27.279C69.1845 29.9773 80.2495 41.6058 81.5501 54.3757C82.7785 66.4359 78.9508 79.1606 67.0393 83.9895C60.8307 86.5065 54.3066 85.9774 50.3816 79.9916C44.385 70.8468 49.81 56.3391 55.7861 48.638C74.4363 24.6043 109.378 10.3369 139.445 15.8037",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 219",
    d: "M121.251 2C125.831 4.74772 136.089 11.3423 140.485 15.7386",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 220",
    d: "M140.485 15.7383C135.906 18.486 125.648 25.0805 121.251 29.4769",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyArrow3);
export default __webpack_public_path__ + "static/media/party-arrow3.19bae50aeb2db4ebadbea461c1a753c4.svg";
export { ForwardRef as ReactComponent };